module.exports = __webpack_public_path__ + "static/7-7cccbe0ffb0e98eb521bd618ee2f7f85.png";